import { defineStore } from 'pinia';
import { ref } from 'vue';
import { identityServerClient } from '../sdk/identityServerClient.js';

/**
 * The person's active sessions, one per device, as the Sign-in & security page
 * shows them. Signing out everywhere is the session store's, because it ends
 * this session too; signing out another device is here, because it does not.
 */
export const sessionsStore = defineStore('sessionsStore', () => {
  const sessions = ref([]);
  const loading = ref(false);
  const error = ref(null);

  async function refresh() {
    loading.value = true;
    error.value = null;
    try {
      sessions.value = await identityServerClient.listSessions();
    } catch (e) {
      error.value = e?.body?.error || 'SESSIONS_REFRESH_FAILED';
    } finally {
      loading.value = false;
    }
  }

  // Throws when the identity server could not do it, so the page can say so;
  // the row stays until it is gone.
  async function signOutDevice(deviceId) {
    await identityServerClient.revokeDevice(deviceId);
    sessions.value = sessions.value.filter((session) => session.id !== deviceId);
  }

  return { sessions, loading, error, refresh, signOutDevice };
});
